var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('cart-quantity-selector',{attrs:{"storage":_vm.cartItem.storage},on:{"input":_vm.update},model:{value:(_vm.cartData.quantity),callback:function ($$v) {_vm.$set(_vm.cartData, "quantity", $$v)},expression:"cartData.quantity"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }